var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-item bg-secondary"},[_c('div',[_c('div',{staticClass:"stats-item-value text-primary text-white-100"},[_vm._v(" "+_vm._s(_vm.filteredValue)+" ")]),_c('div',{staticClass:"stats-item-text text-white-400 capitalize"},[_vm._v(" "+_vm._s(_vm.field.title)+" ")])]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }